"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOG2EDocs = void 0;
var LOG2EDocs = exports.LOG2EDocs = {
  name: 'LOG2E',
  category: 'Constants',
  syntax: ['LOG2E'],
  description: 'Returns the base-2 logarithm of E, approximately equal to 1.442',
  examples: ['LOG2E', 'log(e, 2)'],
  seealso: []
};